import {
  createDocumentDataFieldGroup,
  FieldGroupModel,
} from '../../models/extraction-models/extraction-models';
import { FieldType } from '@ps-gui/shared-utils';
import { Validations } from '@ps-gui/ui';

export const AuftragAttestSections: FieldGroupModel[] = [
  createDocumentDataFieldGroup(),
  {
    key: 'attest_auftragsdaten',
    label: 'Auftragsdaten',
    index: 0,
    fieldModels: [
      {
        key: 'attest_schadennumer',
        label: {
          text: 'Schadennumer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 1,
        validators: [Validations.required()],
      },
      {
        key: 'attest_teilschadennummer',
        label: {
          text: 'Teilschadennummer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 2,
      },
      {
        key: 'attest_schadendatum',
        label: {
          text: 'Schadendatum',
          genus: 'N',
        },
        type: FieldType.DATE,
        index: 3,
        validators: [Validations.required()],
      },
    ],
    type: 'fieldGroupModel',
  },
  {
    key: 'attest_sachbearbeiter',
    label: 'Sachbearbeiter',
    index: 4,
    fieldModels: [
      {
        key: 'attest_sachbearbeiter_vorname',
        label: {
          text: 'Vorname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 5,
        validators: [Validations.required()],
      },
      {
        key: 'attest_sachbearbeiter_nachname',
        label: {
          text: 'Nachname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 6,
        validators: [Validations.required()],
      },
      {
        key: 'attest_sachbearbeiter_email',
        label: {
          text: 'E-Mail',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 7,
        validators: [Validations.required()],
      },
      {
        key: 'attest_sachbearbeiter_telefon',
        label: {
          text: 'Telefon',
          genus: 'N',
        },
        type: FieldType.STRING,
        index: 8,
        validators: [Validations.required()],
      },
    ],
    type: 'fieldGroupModel',
  },
  {
    key: 'attest_betroffene_person',
    label: 'Betroffene Person',
    index: 9,
    fieldModels: [
      {
        key: 'attest_betroffene_person_geschlecht',
        label: {
          text: 'Geschlecht',
          genus: 'N',
        },
        type: FieldType.DROPDOWN,
        options: [
          {
            value: 'U',
            label: 'keine Angabe',
          },
          {
            value: 'M',
            label: 'Männlich',
          },
          {
            value: 'W',
            label: 'Weiblich',
          },
          {
            value: 'D',
            label: 'Divers',
          },
        ],
        index: 10,
      },
      {
        key: 'attest_betroffene_person_vorname',
        label: {
          text: 'Vorname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 11,
        validators: [Validations.required()],
      },
      {
        key: 'attest_betroffene_person_nachname',
        label: {
          text: 'Nachname',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 12,
        validators: [Validations.required()],
      },
      {
        key: 'attest_betroffene_person_geburtsdatum',
        label: {
          text: 'Geburtsdatum',
          genus: 'N',
        },
        type: FieldType.DATE,
        index: 13,
        validators: [Validations.required()],
      },
      {
        key: 'attest_betroffene_person_strasse_hausnummer',
        label: {
          text: 'Straße und Hausnummer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 14,
        validators: [Validations.required()],
      },
      {
        key: 'attest_betroffene_person_postleitzahl',
        label: {
          text: 'Postleitzahl',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 16,
        validators: [Validations.required()],
      },
      {
        key: 'attest_betroffene_person_ort',
        label: {
          text: 'Ort',
          genus: 'M',
        },
        type: FieldType.STRING,
        index: 17,
        validators: [Validations.required()],
      },
      {
        key: 'attest_betroffene_person_email',
        label: {
          text: 'E-Mail Adresse',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 18,
      },
      {
        key: 'attest_betroffene_person_telefonnummer',
        label: {
          text: 'Telefonnummer',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 18,
      },
      {
        key: 'attest_betroffene_person_beruf',
        label: {
          text: 'Beruf',
          genus: 'F',
        },
        type: FieldType.STRING,
        index: 19,
      },
    ],
    type: 'fieldGroupModel',
  },
  {
    key: 'attest_anzufragende_ärzte',
    label: 'Anzufragende Ärzte',
    index: 20,
    fieldModels: [
      {
        key: 'attest_anzufragende_ärzte_zu_beauftragende_ärzte',
        label: {
          text: 'Zu beauftragende Ärzte',
          genus: 'F',
        },
        type: FieldType.TEXTAREA,
        index: 21,
      },
    ],
    type: 'fieldGroupModel',
  },
];
